export default function Select({
  label,
  name,
  value,
  onChange,
  options = [],
  disabledOptions = [],
  className = "",
  labelClassName = "",
  disabled = false,
  required = false,
}) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className={`text-sm font-medium ${labelClassName}`}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <select
        name={name}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        className={`w-full px-3 py-2 border rounded-md text-[11px] sm:text-sm ${className}`}
      >
        <option value="">Select</option>

        {options.map((opt) => (
          <option
            key={opt}
            value={opt}
            disabled={disabledOptions.includes(opt)}
          >
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
}
